import type {
  FairDropdownGroup,
  FairDropdownOption,
  FairDropdownOptions,
} from '@/ui/tokens/inputs.data'
import { isGroupedDropdownOptions } from '@/ui/tokens/inputs.data'

function normalizeQuery(query: string): string {
  return query.trim().toLowerCase()
}

function matchesLabel(label: string, query: string): boolean {
  return label.toLowerCase().includes(query)
}

export function filterDropdownOptions(
  options: FairDropdownOption[],
  query: string,
): FairDropdownOption[] {
  const normalized = normalizeQuery(query)

  if (!normalized) {
    return options
  }

  return options.filter((option) => matchesLabel(option.label, normalized))
}

export function filterGroupedDropdownOptions(
  groups: FairDropdownGroup[],
  query: string,
): FairDropdownGroup[] {
  const normalized = normalizeQuery(query)

  if (!normalized) {
    return groups
  }

  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((item) => matchesLabel(item.label, normalized)),
    }))
    .filter((group) => group.items.length > 0)
}

export function filterDropdownSource(
  source: FairDropdownOptions,
  query: string,
): FairDropdownOptions {
  if (!source.length) {
    return source
  }

  if (isGroupedDropdownOptions(source)) {
    return filterGroupedDropdownOptions(source, query)
  }

  return filterDropdownOptions(source, query)
}
